"use client";

import { motion } from "framer-motion";
import { Github, Linkedin, Twitter, Mail } from "lucide-react";

const SocialIcons = () => {
  const icons = [
    {
      icon: <Github size={18} />,
      href: "https://github.com/behes",
      label: "GitHub",
    },
    {
      icon: <Linkedin size={18} />,
      href: "https://linkedin.com/in/behes",
      label: "LinkedIn",
    },
    {
      icon: <Twitter size={18} />,
      href: "https://twitter.com/behesdev",
      label: "Twitter",
    },
    {
      icon: <Mail size={18} />,
      href: "mailto:hello@behes.dev",
      label: "Email",
    },
  ];

  return (
    <div className="flex items-center gap-4">
      {icons.map((item, index) => (
        <motion.a
          key={item.label}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={item.label}
          className="w-8 h-8 rounded-full bg-[var(--bg-tertiary)]/50 border border-[var(--border-color)] flex items-center justify-center text-[var(--text-secondary)] hover:text-[var(--brand-color)] hover:border-[var(--brand-color)] transition-colors"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.1 * index }}
        >
          {item.icon}
        </motion.a>
      ))}
    </div>
  );
};

export default SocialIcons;
